import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import ajax from './utils/ajax'
import functions from './utils/functions'
import Home from './pages/Home';


class App extends Component {


  state = {
    screen: "Login",
    loggedIn: true,
  }

  componentDidMount() {
    this.checkLogin();
  }

  checkLogin() {
    if (!localStorage.getItem("pesaapi@user")) {
      this.setState({
        loggedIn: false
      })
    } else {
      this.setState({
        loggedIn: true
      })
    }
  }

  render() {
    // const roleList = functions.roleGuard()
    return (
      <Router forceRefresh={true}>

        <Switch>
          {/* {!this.state.loggedIn && <Route exact path="/" component={Home} />} */}
          <Route exact path="/" component={Home} />


        </Switch>
      </Router>
    )
  }
}
export default App
